// @flow
import React from 'react';
import type { Element } from 'react';
import { withTranslation } from '@i18n';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TimelineRight } from '@images/svg/index';
import { requestPackageDetails } from '@screens/Details/Package/redux/actions';
import { PackageMiniflow } from '@components';
import type { GlobalState, I18nProps } from '@globalTypes';

import {
  StyledCover,
  StyledFormWrapper,
  StyledTimelineCover,
  StyledTimelineWrapper,
  StyledTextWrapper,
  StyledDisabledTimelineIcon,
  StyledTimelineIconWrapper,
  StyledUnit,
  StyledHrLine,
  StyledGridHeading,
  TextWrapper,
  Text
} from './styles';

export type Props = {
  packageFormScreen: Boolean,
  paymentScreen: Boolean,
  isBooking: Boolean,
  paymentSuccessfull: Boolean
} & I18nProps;

export const FormFlowTimeline = withTranslation('ProfilePackages')(
  ({
    t, packageFormScreen, paymentScreen, isBooking, paymentSuccessfull
  }: Props): Element<any> => (
    <StyledTimelineCover>

      <StyledGridHeading>
        <Text>
          <StyledTextWrapper
            paymentScreen={paymentScreen}
            paymentSuccessfull={paymentSuccessfull}
            packageFormScreen={packageFormScreen}
          >
            {isBooking ? t('BookingDone') : t('BookPackage')}
          </StyledTextWrapper>
        </Text>

        <TextWrapper>
          <StyledTextWrapper
            paymentScreen={paymentScreen}
            paymentSuccessfull={paymentSuccessfull}
          >
            {t('PayNow')}
          </StyledTextWrapper>
        </TextWrapper>

        <Text>
          <StyledTextWrapper
            id="successfulPayment"
            paymentSuccessfull={paymentSuccessfull}
          >
            {t('SuccessfullyCompleted')}
          </StyledTextWrapper>
        </Text>
      </StyledGridHeading>

      <StyledTimelineWrapper>

        <StyledUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>


          <StyledDisabledTimelineIcon packageFormScreen={packageFormScreen}>
            <StyledTimelineIconWrapper packageFormScreen={packageFormScreen}>
              <TimelineRight packageFormScreen={packageFormScreen} />
            </StyledTimelineIconWrapper>
          </StyledDisabledTimelineIcon>

        </StyledUnit>

        <StyledHrLine />
        <StyledUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>
          <StyledDisabledTimelineIcon paymentScreen={paymentScreen}>
            <StyledTimelineIconWrapper
              packageFormScreen={packageFormScreen}
              paymentScreen={paymentScreen}
              paymentSuccessfull={paymentSuccessfull}
            >
              <TimelineRight
                packageFormScreen={packageFormScreen}
                paymentScreen={paymentScreen}
                paymentSuccessfull={paymentSuccessfull}
              />
            </StyledTimelineIconWrapper>
          </StyledDisabledTimelineIcon>

        </StyledUnit>
        <StyledHrLine />
        <StyledUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>
          <StyledDisabledTimelineIcon paymentSuccessfull={paymentSuccessfull}>
            <StyledTimelineIconWrapper
              packageFormScreen={packageFormScreen}
              paymentScreen={paymentScreen}
              paymentSuccessfull={paymentSuccessfull}
            >
              <TimelineRight
                packageFormScreen={packageFormScreen}
                paymentScreen={paymentScreen}
                paymentSuccessfull={paymentSuccessfull}
              />
            </StyledTimelineIconWrapper>
          </StyledDisabledTimelineIcon>

        </StyledUnit>
      </StyledTimelineWrapper>
    </StyledTimelineCover>
  )
);

const ProfilePackageForm = ({ packageData, packageDetails }): Element<any> => {
  const tenPercentPrice = () => {
    const finalPrice = packageDetails?.data?.attributes?.selling_price || 0;
    return (finalPrice / 100) * packageDetails?.data?.attributes?.booking_percentage || 10;
  };
  return (
    <StyledCover>
      <StyledFormWrapper size={{ mobile: 1 / 1 }}>
        <PackageMiniflow
          packageFormScreen
          packageData={packageData !== undefined ? packageData : packageDetails}
          amount={tenPercentPrice()}
          hideTimeLine
        />
      </StyledFormWrapper>
    </StyledCover>
  );
};

ProfilePackageForm.getInitialProps = async ({ query, store }) => {
  const { dispatch, getState } = store;
  const packageDetails = getState();
  const { data } = packageDetails;

  if (!data) {
    await dispatch(requestPackageDetails(query.slug));
  }

  return {
    namespacesRequired: ['ProfilePackages'],
    query
  };
};
const mapStateToProps = ({ packageDetails }: GlobalState): {} => ({
  packageDetails
});

export default compose(
  withTranslation('ProfilePackage'),
  connect(
    mapStateToProps,
    { requestPackageDetails }
  )
)(ProfilePackageForm);
